import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const CholesterolHistoryPage = lazy(() => import("./CholesterolHistoryPage"));

const CholesterolHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <CholesterolHistoryPage />
    </Suspense>
  );
};

export default CholesterolHistoryPageLazy;
